import React from 'react';

const CheckIcon = ({ size = 74 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 74 74"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M32.004 54.0575L57.9169 28.1447L52.7711 22.9989L32.004 43.7659L21.5286 33.2905L16.3828 38.4363L32.004 54.0575ZM37.1499 73.9057C32.0653 73.9057 27.287 72.9408 22.8151 71.0111C18.3431 69.0815 14.4531 66.4626 11.1451 63.1546C7.8371 59.8466 5.21824 55.9566 3.28856 51.4846C1.35888 47.0127 0.394043 42.2344 0.394043 37.1499C0.394043 32.0653 1.35888 27.287 3.28856 22.8151C5.21824 18.3431 7.8371 14.4531 11.1451 11.1451C14.4531 7.8371 18.3431 5.21824 22.8151 3.28856C27.287 1.35888 32.0653 0.394043 37.1499 0.394043C42.2344 0.394043 47.0127 1.35888 51.4846 3.28856C55.9566 5.21824 59.8466 7.8371 63.1546 11.1451C66.4626 14.4531 69.0815 18.3431 71.0111 22.8151C72.9408 27.287 73.9057 32.0653 73.9057 37.1499C73.9057 42.2344 72.9408 47.0127 71.0111 51.4846C69.0815 55.9566 66.4626 59.8466 63.1546 63.1546C59.8466 66.4626 55.9566 69.0815 51.4846 71.0111C47.0127 72.9408 42.2344 73.9057 37.1499 73.9057ZM37.1499 66.5545C45.3587 66.5545 52.3116 63.7059 58.0088 58.0088C63.7059 52.3116 66.5545 45.3587 66.5545 37.1499C66.5545 28.9411 63.7059 21.9881 58.0088 16.2909C52.3116 10.5938 45.3587 7.74521 37.1499 7.74521C28.9411 7.74521 21.9881 10.5938 16.2909 16.2909C10.5938 21.9881 7.74521 28.9411 7.74521 37.1499C7.74521 45.3587 10.5938 52.3116 16.2909 58.0088C21.9881 63.7059 28.9411 66.5545 37.1499 66.5545Z"
      fill="#03A65A"
    />
  </svg>
);

export default CheckIcon;
